<script>
  import Col from "./Col.svelte";

  export let value = $$props.preSelected || $$props.value;
  const id = `cookie-banner-toggle-button-${$$props.key}`;

  const onClick = () => {
    $$props.onDetailToggle($$props.key);
  };
  const {config} = $$props;
</script>

<style>
  .privacy-consent--label {
    font-size: 16px;
  }

  @media screen and (max-height: 820px) {
    .privacy-consent--label {
      font-size: 12px;
    }
  }

  .privacy-consent--label {
    padding-left: 24px !important;
    padding-left: 1.5rem !important;
    padding-right: 24px !important;
    padding-right: 1.5rem !important;
  }

  .privacy-consent--label,
  .privacy-consent--label-details {
    position: relative;
    width: 100%;
    min-height: 1px;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 50%;
    -webkit-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }

  .privacy-consent--label-details {
    font-size: 16px;
    text-align: right;
  }

  @media screen and (min-height: 450px) {
    .privacy-consent--label {
      margin-top: 8px;
    }

    .privacy-consent--label-details {
      padding-left: 24px !important;
      padding-left: 1.5rem !important;
      padding-right: 24px !important;
      padding-right: 1.5rem !important;
      margin-top: 8px;
    }
  }

  .privacy-consent--input {
    clip: rect(0,0,0,0);
    position: absolute;
    visibility: hidden;
  }

  .privacy-consent--input:checked + .privacy-consent--label-content:before {
    background-image: url('data:image/svg+xml;base64,PHN2ZyBpZD0iSUNPTiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMzIgMzIiPjx0aXRsZT5pYy1zLWJvbGQtcm91bmQtY2hlY2ttYXJrPC90aXRsZT48cGF0aCBpZD0iaWMtcy1ib2xkLXJvdW5kLWNoZWNrbWFyayIgZD0iTTEyLDMyYTMsMywwLDAsMS0yLjQtMS4ybC05LTEyYTMsMywwLDEsMSw0LjgtMy42bDYuNDMyLDguNTc1TDI2LjQ4OSwxLjM1OGEzLDMsMCwxLDEsNS4wMjIsMy4yODRsLTE3LDI2QTMsMywwLDAsMSwxMi4xLDMyWiIgc3R5bGU9ImZpbGw6IzI4Q0NFOCIvPjwvc3ZnPgo=');
  }
  .privacy-consent--input:disabled + .privacy-consent--label-content {
    color: #95a0b0;
  }

  .privacy-consent--input:disabled + .privacy-consent--label-content:before {
    border-color: #dfe2e7;
    background-image: url('data:image/svg+xml;base64,PHN2ZyBpZD0iSUNPTiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMzIgMzIiPjx0aXRsZT5pYy1zLWJvbGQtcm91bmQtY2hlY2ttYXJrPC90aXRsZT48cGF0aCBpZD0iaWMtcy1ib2xkLXJvdW5kLWNoZWNrbWFyayIgZD0iTTEyLDMyYTMsMywwLDAsMS0yLjQtMS4ybC05LTEyYTMsMywwLDEsMSw0LjgtMy42bDYuNDMyLDguNTc1TDI2LjQ4OSwxLjM1OGEzLDMsMCwxLDEsNS4wMjIsMy4yODRsLTE3LDI2QTMsMywwLDAsMSwxMi4xLDMyWiIgc3R5bGU9ImZpbGw6I0RGRTJFNyIvPjwvc3ZnPgo=');
  }

  .privacy-consent--label-content:before {
    content: '';
    left: 0;
    top: 0;
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    border: 2px solid #95a0b0;
    border-radius: 3px;
    background-size: 70%;
    background-repeat: no-repeat;
    background-position: center;
    margin-right: 10px;
  }

  .privacy-consent--label-content {
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: nowrap;
    -webkit-flex-wrap: nowrap;
    flex-wrap: nowrap;
    cursor: hand;
    cursor: pointer;
  }

  .privacy-consent--label-details + .privacy-consent--label,
  .privacy-consent--label-details + .privacy-consent--label + .privacy-consent--label-details {
    padding-top: 32px;
  }

  .privacy-consent--label-details span {
    color: #0b9dcc;
    cursor: pointer;
    text-decoration: none;
    word-wrap: break-word;
  }

  .privacy-consent--label-details span:after {
    content: '';
    background: url('data:image/svg+xml;base64,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') no-repeat center center;
    display: inline-block;
    width: 13px;
    height: 10px;
    background-size: contain;
    margin-left: 10px;
  }

  .privacy-consent--label-details .privacy-consent--label-active:after {
    background-image: url('data:image/svg+xml;base64,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');
  }

  .privacy-consent--label-details span:hover {
    text-decoration: underline;
  }

  @media screen and (max-height: 450px) {
    .privacy-consent--label-details {
      padding-left: 24px !important;
      padding-left: 1.5rem !important;
    }
  }

  @media screen and (max-height: 820px) {
    .privacy-consent--label-details {
      font-size: 12px;
    }
  }

  @media screen and (max-width: 530px) {
    .privacy-consent--label-details + .privacy-consent--label,
    .privacy-consent--label-details + .privacy-consent--label + .privacy-consent--label-details {
      padding-top: 12px;
    }

    .privacy-consent--label-details {
      font-size: 12px;
    }
  }

  @media screen and (min-width: 850px), (max-height: 450px) {
    .privacy-consent--label-details {
      text-align: left;
    }

    .privacy-consent--label-details + .privacy-consent--label,
    .privacy-consent--label-details + .privacy-consent--label + .privacy-consent--label-details {
      padding-top: 0;
    }

    .privacy-consent--label,
    .privacy-consent--label-details {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 25%;
      -webkit-flex: 0 0 25%;
      flex: 0 0 25%;
      max-width: 25%;
    }

    .privacy-consent--label {
      -webkit-box-ordinal-group: 1;
      -ms-flex-order: 0;
      -webkit-order: 0;
      order: 0;
    }
    .privacy-consent--label-details {
      -webkit-box-ordinal-group: 2;
      -ms-flex-order: 1;
      -webkit-order: 1;
      order: 1;
    }

    .privacy-consent--label-details span {
      display: inline-block;
      margin-left: 34px;
      margin-top: 8px;
    }
  }
  @media screen and (min-width: 933px) {
    .privacy-consent--label.test,
    .privacy-consent--label-details.test {
      font-size: 12px !important;
    }
  }
</style>

<div class="privacy-consent--label {config.alternativeDisplay === true ? 'test' : ''}">
  <input {id} type="checkbox" class="privacy-consent--input" disabled={$$props.disabled} bind:checked={value} />
  <label class="privacy-consent--label-content" for={id}>{$$props.label}</label>
</div>

<div class="privacy-consent--label-details {config.alternativeDisplay === true ? 'test' : ''}">
  <span class="{$$props.detailKey === $$props.key ? 'privacy-consent--label-active' : ''}" on:click={onClick}>{$$props.toggleLabel}</span>
</div>
